import { supabase } from '../../lib/supabase';
import type { Database } from '../../types/supabase';

export const supabaseLotService = {
  getAll: async () => {
    const { data, error } = await supabase
      .from('land_lots')
      .select(`
        lot_id,
        laiskey,
        plan_lot,
        lot_perm_use,
        lot_zone,
        lot_serviced,
        lot_community,
        lot_avail,
        lot_surr,
        lot_surr_note,
        created_by,
        created_date,
        modified_by,
        modified_date,
        lot_desc,
        lot_note
      `)
      .order('created_date', { ascending: false });

    if (error) throw error;
    return data;
  },

  getById: async (lotId: string) => {
    const { data, error } = await supabase
      .from('land_lots')
      .select(`
        lot_id,
        laiskey,
        plan_lot,
        lot_perm_use,
        lot_zone,
        lot_serviced,
        lot_community,
        lot_avail,
        lot_surr,
        lot_surr_note,
        created_by,
        created_date,
        modified_by,
        modified_date,
        lot_desc,
        lot_note
      `)
      .eq('lot_id', lotId)
      .single();

    if (error) throw error;
    return data;
  },

  getByCommunity: async (communityCode: string) => {
    const { data, error } = await supabase
      .from('land_lots')
      .select(`
        lot_id,
        laiskey,
        plan_lot,
        lot_perm_use,
        lot_zone,
        lot_serviced,
        lot_community,
        lot_avail,
        lot_surr,
        lot_surr_note,
        created_by,
        created_date,
        modified_by,
        modified_date,
        lot_desc,
        lot_note
      `)
      .eq('lot_community', communityCode)
      .order('created_date', { ascending: false });

    if (error) throw error;
    return data;
  },

  getAvailable: async () => {
    const { data, error } = await supabase
      .from('land_lots')
      .select(`
        lot_id,
        laiskey,
        plan_lot,
        lot_perm_use,
        lot_zone,
        lot_serviced,
        lot_community,
        lot_avail,
        lot_surr,
        lot_surr_note,
        created_by,
        created_date,
        modified_by,
        modified_date,
        lot_desc,
        lot_note
      `)
      .eq('lot_avail', 'Y')
      .eq('lot_surr', 'N')
      .order('created_date', { ascending: false });

    if (error) throw error;
    return data;
  },

  getLotsByIds: async (lotIds: string[]) => {
    if (!lotIds || lotIds.length === 0) {
      return [];
    }
    const { data, error } = await supabase
      .from('land_lots')
      .select(`
        lot_id,
        laiskey,
        plan_lot,
        lot_perm_use,
        lot_zone,
        lot_serviced,
        lot_community,
        lot_avail,
        lot_surr,
        lot_surr_note,
        created_by,
        created_date,
        modified_by,
        modified_date,
        lot_desc,
        lot_note
      `)
      .in('lot_id', lotIds)
      .order('lot_id', { ascending: true });

    if (error) {
      console.error('Error fetching lots by IDs:', error);
      throw error;
    }
    return data || [];
  },

  getSelectableLotsForAssociation: async () => {
    const { data, error } = await supabase
      .from('land_lots')
      .select(`
        lot_id,
        laiskey,
        plan_lot,
        lot_perm_use,
        lot_zone,
        lot_serviced,
        lot_community,
        lot_avail,
        lot_surr,
        lot_surr_note,
        created_by,
        created_date,
        modified_by,
        modified_date,
        lot_desc,
        lot_note
      `)
      .eq('lot_avail', 'Y') // Filter by lot_avail = 'Y'
      // No filter for lot_surr as per latest requirement
      .order('lot_id', { ascending: true });
    
    if (error) {
      console.error('Error fetching selectable lots for association:', error);
      throw error;
    }
    return data || [];
  }
};
